import { useMemo, useSyncExternalStore } from "react";
import { marketingAnalytics } from "./lazyAnalytics";
import { createMarketingCapture } from './capture';

const serverSnapshot = () => undefined;

/** Existing event consumers update when consented initialization finishes. */
export function usePostHog() {
  const client = useSyncExternalStore(
    marketingAnalytics.subscribe,
    marketingAnalytics.getClient,
    serverSnapshot,
  );
  return useMemo(() => client ? createMarketingCapture(client) : undefined, [client]);
}
